import { useApi } from '@/api';
import { ChartTimeFilter, ChartSkeleton } from '@/components';
import { formatNumber, CurrencyValue, BarChart } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import { tokensMapping } from '@/utils/tokens';
import { useTheme } from 'styled-components';
import { useChartPeriod } from '@/hooks';

export default function STUSDSDepositorsVolumeChart() {
  const theme = useTheme();
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi({
    url: '/stusds/historic/',
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  const datasets = useMemo(() => {
    return [
      {
        xField: 'date',
        yField: 'deposit_volume',
        label: 'Deposit',
        backgroundColor: theme.colors.chartUp
      },
      {
        xField: 'date',
        yField: 'withdraw_volume',
        label: 'Withdraw',
        backgroundColor: theme.colors.chartDown
      }
    ];
  }, [theme.colors]);
  const yScaleValueFormatter = (value) => {
    return formatNumber(Number(value));
  };
  const valueFormatter = useMemo(() => {
    function formatValue(value: string) {
      return (
        <CurrencyValue
          value={Number(value)}
          options={{
            currency: tokensMapping('stUSDS'),
            iconSize: '0'
          }}
        />
      );
    }
    return formatValue;
  }, []);

  if (data) {
    return (
      <BarChart
        key="Volume"
        data={data.volume}
        datasets={datasets}
        valueFormatter={valueFormatter}
        yScaleValueFormatter={yScaleValueFormatter}
        timeFilter={timeFilter}
        config={config}
      />
    );
  }

  return <ChartSkeleton />;
}
